import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '../../../lib/types/types';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';

const MedicalStatusComponent = ({
    value,
    isErrored,
    options,
    onChange,
    onKeyDown = undefined,
}: InputSelectComponentProps) => {
    return (
        <div className="sid-field sid-medical-status">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-medical-status">
                <div className="sid-field__label sid-field__label--required sid-medical-status__label sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="status"
                        defaultMessage="Status"
                    />
                </div>
            </label>
            <InputSelectComponent
                fieldId="status"
                inputId="sid-medical-status"
                isErrored={isErrored}
                options={options}
                onChange={(status: FormSelectChoice) => onChange(status)}
                onKeyDown={onKeyDown}
                value={value}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidStatus"
                            defaultMessage="Invalid medical status"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { MedicalStatusComponent };
